import { GetNewProductsParameter, GetNewProductsResponseModel, NewProductsCustomStateModel } from "@electricMotorShop/Types/NewProductModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type NewProductsState = Readonly<{
    requestCache: NewProductsCustomStateModel[];
}>;

const initialState: NewProductsState = {
    requestCache: [],
};

const NewProductsData = createTypedReducerWithImmer(initialState, {
    "Custom/NewProducts/BeginLoad": (
        draft: Draft<NewProductsState>,
        action: { params: GetNewProductsParameter}
    ) => {
        const existingIndex = draft.requestCache.findIndex(
            c => c.params.categoryId === action.params.categoryId &&
                 c.params.pageSize === action.params.pageSize && 
                 c.params.returnCategories === action.params.returnCategories && 
                 c.params.returnProductDtos === action.params.returnProductDtos);
        if (existingIndex > -1) {
            draft.requestCache[existingIndex].newProductsAreLoading = true;
            draft.requestCache[existingIndex].newProductsLoaded = false;
            draft.requestCache[existingIndex].results.newProductCategories = [];
            draft.requestCache[existingIndex].results.newProductDtos = [];
            draft.requestCache[existingIndex].results.newProducts = [];
        } else {
            const newRequestCacheItem: NewProductsCustomStateModel = {
                results: {
                    newProductCategories: [],
                    newProductDtos: [],
                    newProducts: [],
                },
                params: {
                    categoryId: action.params.categoryId,
                    pageSize: action.params.pageSize,
                    returnCategories: action.params.returnCategories,
                    returnProductDtos: action.params.returnProductDtos,
                },
                newProductsAreLoading: true,
                newProductsLoaded: false,
            };
            draft.requestCache.push(newRequestCacheItem);
        }
    },
    "Custom/NewProducts/CompleteLoad": (
        draft: Draft<NewProductsState>,
        action: { 
            result: GetNewProductsResponseModel, 
            params: GetNewProductsParameter 
        },
    ) => {
        const existingIndex = draft.requestCache.findIndex(
            c => c.params.categoryId === action.params.categoryId &&
                 c.params.pageSize === action.params.pageSize && 
                 c.params.returnCategories === action.params.returnCategories && 
                 c.params.returnProductDtos === action.params.returnProductDtos);
        if (existingIndex > -1) {
            draft.requestCache[existingIndex].newProductsAreLoading = false;
            draft.requestCache[existingIndex].newProductsLoaded = true;
            draft.requestCache[existingIndex].results.newProductCategories = action.result.categories || [];
            draft.requestCache[existingIndex].results.newProductDtos = action.result.productDtos || [];
            draft.requestCache[existingIndex].results.newProducts = action.result.products || [];
        } else {
            const newRequestCacheItem: NewProductsCustomStateModel = {
                results: {
                    newProductCategories: action.result.categories || [],
                    newProductDtos: action.result.productDtos || [],
                    newProducts: action.result.products || [],
                },
                params: {
                    categoryId: action.params.categoryId,
                    pageSize: action.params.pageSize,
                    returnCategories: action.params.returnCategories,
                    returnProductDtos: action.params.returnProductDtos,
                },
                newProductsAreLoading: false,
                newProductsLoaded: true,
            };
            draft.requestCache.push(newRequestCacheItem);
        }
    },
});

export default (reducers as any).xcentiumNewProducts = NewProductsData;

export type CustomNewProuctsState = {
    xcentiumNewProducts: NewProductsState;
} & ApplicationState;

type Reducers = {
    newProductsReducer: typeof NewProductsData;
};

export type xcentiumNewProductActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
